export default __webpack_public_path__ + "static/media/08_photo.d2e7147f.jpg";